import '../vendor/jquery.nicescroll';

export default class Scroll {
  constructor() {
    this.$scrollWrap = $('.item-wrap');
  }

  // custumScroll() {
  //   this.$scrollWrap.niceScroll({
  //     cursorcolor: 'rgba(255,255,255,0.5)',
  //     cursorwidth: '14px',
  //     background: 'rgba(255,255,255,0.3)',
  //     cursorborderradius: 0,
  //   });
  // }

  popupScroll() {
    $('.article-popup').niceScroll({
      cursorcolor: 'rgba(255,255,255,0.5)',
      cursorwidth: '14px',
      background: 'rgba(255,255,255,0.3)',
      cursorborderradius: 0,
    });
  }

  endScroll() {
    console.log($('.article-popup').getNiceScroll());
  }

  init() {
    // this.custumScroll();
    this.popupScroll();
    this.endScroll();
  }
}
